import { useEffect, useSyncExternalStore } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button } from '../../ui/index.tsx';

// Si hay una versión nueva esperando: los avisos modales obligatorios (como elegir la contraseña)
// esperan, porque un <dialog> modal tapa este aviso y no dejaría tocar «Actualizar».
let pending = false;
const listeners = new Set<() => void>();
function setPending(value: boolean) {
  if (value === pending) return;
  pending = value;
  for (const l of listeners) l();
}

export function useUpdatePending(): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => pending,
  );
}

/**
 * Aviso de versión nueva. No se actualiza sola para no recargar en medio de una venta:
 * el usuario elige el momento.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Busca actualizaciones cada hora mientras la app está abierta.
      if (registration) setInterval(() => void registration.update(), 60 * 60_000);
    },
  });

  useEffect(() => setPending(needRefresh), [needRefresh]);

  if (!needRefresh && !offlineReady) return null;

  return (
    <div className="fixed inset-x-4 bottom-20 z-50 mx-auto max-w-md rounded-xl bg-slate-900 p-4 text-sm text-white shadow-raised md:bottom-6">
      {needRefresh ? (
        <div className="flex items-center justify-between gap-3">
          <span>Hay una versión nueva disponible.</span>
          <div className="flex gap-2">
            <Button size="md" variant="onDark" onClick={() => setNeedRefresh(false)}>
              Después
            </Button>
            <Button size="md" onClick={() => void updateServiceWorker(true)}>
              Actualizar
            </Button>
          </div>
        </div>
      ) : (
        <div className="flex items-center justify-between gap-3">
          <span>Listo: la app ya funciona sin internet en este dispositivo.</span>
          <Button size="md" variant="onDark" onClick={() => setOfflineReady(false)}>
            OK
          </Button>
        </div>
      )}
    </div>
  );
}
